export default __webpack_public_path__ + "static/media/stress.db281e9b.svg";